import { render, staticRenderFns } from "./subjects-of-allegation-worker-form.vue?vue&type=template&id=9f486f22&scoped=true"
import script from "./subjects-of-allegation-worker-form.vue?vue&type=script&lang=js"
export * from "./subjects-of-allegation-worker-form.vue?vue&type=script&lang=js"
import style0 from "./subjects-of-allegation-worker-form.vue?vue&type=style&index=0&id=9f486f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f486f22",
  null
  
)

export default component.exports